import type { WorkflowBox } from "./models";

type Choice = { value: string; label: string; code?: string };

/** Use the existing IBIC coding presentation while keeping configured option values. */
export function previewChoicePresentation(box: WorkflowBox, ibicLabel: string): { label: string; options: readonly Choice[] } {
    const isIbic = box.title.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim() === "ibic coding";
    if (!isIbic) return { label: box.title, options: box.options };
    return {
        label: ibicLabel,
        options: box.options.map(option => {
            const code = /^[dbe]\d{1,4}[a-z]?$/i.test(option.value)
                ? option.value
                : /^([dbe]\d{1,4}[a-z]?)\b/i.exec(option.label)?.[1];
            if (!code) return option;
            return { ...option, code, label: option.label.replace(new RegExp(`^${code}\\b[\\s.:–—-]*`, "i"), "") || option.label };
        })
    };
}
